import * as React from 'react';
import { useMemo } from 'react';

import { AppSection, ProductList } from './index';
import { useAppData, useIntl } from '../providers';
import { Category, Product } from '../interfaces';

interface BranchViewProps {
    category: Category;
}

const BranchView: React.FC<BranchViewProps> = ({ category }: BranchViewProps) => {
    const { translate } = useIntl();
    const { isShop } = useAppData();

    const collectItemsInSubcategories = (categories: Category[]): Product[] => {
        return categories.reduce<Product[]>((items, currentCategory): Product[] => {
            return items.concat(
                currentCategory.jobChoices,
                collectItemsInSubcategories(currentCategory.subCategories)
            );
        }, []);
    };

    const itemsInBranch = useMemo(() => {
        const items = category ? collectItemsInSubcategories([category]) : [];

        const itemIds = [];

        if (!isShop) {
            return items;
        }

        return items
            .filter(item => {
                if (itemIds.indexOf(item.id) == -1) {
                    itemIds.push(item.id);
                    return true;
                }
                return false;
            })
            .sort((a, b) => {
                return a.label > b.label ? 1 : -1;
            });
    }, [category]);

    if (!category) return null;

    return (
        <AppSection>
            <h1>{translate('branchView.header', 'All products in category', { branch: category.label })}</h1>
            <ProductList products={itemsInBranch} />
        </AppSection>
    );
};

export default React.memo(BranchView);
